var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_375_1137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 0H6.48765C6.23003 0 5.9724 0.140625 5.83187 0.351562L4.33294 2.78906C3.53664 4.05469 4.23926 5.78906 5.69135 5.97656C5.80845 6 5.90213 6 6.01924 6C6.72186 6 7.3308 5.69531 7.75237 5.22656C8.17395 5.69531 8.78289 6 9.48551 6C10.066 6 10.5953 5.7774 11 5.42003V0Z",
    fill: "#5062F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9H7.5025V6.67969C7.26829 6.72656 6.25345 6.75 6.01924 6.75C5.87871 6.75 5.73819 6.75 5.59766 6.72656C5.45714 6.70312 5.34004 6.67969 5.22293 6.65625V11.25C5.22293 11.6719 5.55082 12 5.9724 12H11V9Z",
    fill: "#5062F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 0H15.5123C15.77 0 16.0276 0.140625 16.1681 0.351562L17.6671 2.78906C18.4634 4.05469 17.7607 5.78906 16.3087 5.97656C16.1915 6 16.0979 6 15.9808 6C15.2781 6 14.6692 5.69531 14.2476 5.22656C13.8261 5.69531 13.2171 6 12.5145 6C11.934 6 11.4047 5.7774 11 5.42003V0Z",
    fill: "#5062F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 9H14.4975V6.67969C14.7317 6.72656 15.7466 6.75 15.9808 6.75C16.1213 6.75 16.2618 6.75 16.4023 6.72656C16.5429 6.70312 16.66 6.67969 16.7771 6.65625V11.25C16.7771 11.6719 16.4492 12 16.0276 12H11V9Z",
    fill: "#5062F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_375_1137",
    x: 0,
    y: 0,
    width: 22,
    height: 20,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_375_1137"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_375_1137",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.f0c9864d669707bffdf2ea959e8eab81.svg";
export { ForwardRef as ReactComponent };